import { toast } from '@/components/toast';
import { HttpStatus } from '@/errors/http-status';
import { logger } from '@/services/logger';

export const defaultErrorHandler = async (error: any) => {
    logger.error('Could not update agent', { error });
    console.log('error.response?.data?.description', error.response?.data?.description);

    if (error.response?.status === HttpStatus.MAX_EMBED_AGENTS_LIMIT_REACHED) {
        toast.error({ title: error.response?.data?.description, toastId: `agent-update-error` });
    } else {
        toast.error({ title: `Could not update agent`, toastId: `agent-update-error` });
    }
};
